import {getJWT, getUserPayloadFromJWT} from "./security/jwt";
import {isKeyInStorage, getKeyFromStorage, setKeyInStorage, deleteKeyFromStorage} from "./storage/local_storage_store";

const USER_AUTH_KEY = "tipzyy.user.authkey";

/**
 * Is authkey in storage?
 *
 * @return {boolean}
 */
const isAuthkeyInStorage = () => isKeyInStorage(USER_AUTH_KEY);

/**
 * Get authkey from storage
 *
 * @return {String|null}
 */
const getAuthkey = () => {
  if (!isAuthkeyInStorage()) {
    return null;
  }

  return getKeyFromStorage(USER_AUTH_KEY);
};

/**
 * Set Authkey (store it)
 *
 * @param jwt {String}
 */
const setAuthkey = jwt => setKeyInStorage(USER_AUTH_KEY, jwt);

/**
 * Delete authkey from storage
 */
const deleteAuthkey = () => deleteKeyFromStorage(USER_AUTH_KEY);

/**
 * Get user first name
 *
 * @return {String|null}
 */
const getUserFirstName = () => {
  const userPayload = getUserPayloadFromJWT(getJWT());
  if (!userPayload) {
    return null;
  }

  return userPayload.firstName;
};

/**
 * Get user last name
 *
 * @return {String|null}
 */
const getUserLastName = () => {
  const userPayload = getUserPayloadFromJWT(getJWT());
  if (!userPayload) {
    return null;
  }

  return userPayload.lastName;
};

/**
 * Get user phone number
 *
 * @return {String|null}
 */
const getUserPhoneNumber = () => {
  const userPayload = getUserPayloadFromJWT(getJWT());
  if (!userPayload) {
    return null;
  }

  const phones = (userPayload.phoneNumbers ? userPayload.phoneNumbers : []).map(p => p.datum);

  return phones.length ? phones[0] : null;
};

/**
 * Get user email address
 *
 * @return {String|null}
 */
const getUserEmailAddress = () => {
  const userPayload = getUserPayloadFromJWT(getJWT());
  if (!userPayload) {
    return null;
  }

  const emails = (userPayload.emailAddresses ? userPayload.emailAddresses : []).map(p => p.datum);

  return emails.length ? emails[0] : null;
};

export {
  getAuthkey,
  setAuthkey,
  deleteAuthkey,
  getUserFirstName,
  getUserLastName,
  getUserEmailAddress,
  getUserPhoneNumber,
};
